import { t } from 'i18next';
import React from 'react'
import { useNavigate } from 'react-router-dom';

export const SectorsSearcher = ({ handleChangeSearchText }) => {
    const navigate = useNavigate();

    return (
        <>
            <div className='mt-2 mb-2'>
                <input
                    placeholder={t('SEARCH')}
                    type={"text"}
                    name={'searchAreas'}
                    className="form-control access-input"
                    autoComplete='off'
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                />
            </div>

            <div className='text-end mt-3 mb-3'>
                <p style={{ fontWeight: '600', fontSize: '16px', lineHeight: '19px', display: 'inline' }}
                    className='m-0 me-1 gray-950-color'
                    onClick={() => navigate('/settings/entityManagment/sectorMaganagement/create')}
                    type="button"
                >
                    {`+ ${t('CREATE')} ${t('SECTOR')}`}
                </p>
            </div>
        </>
    )
}
